import React from "react";
import {
    redirectionWrapper,
    IsEmpty
} from "../../util/commonFunctions";
import ErrorPage from "../shared/ErrorPage";

const SeriesHorizontalWideCard = (props) => {
    return (
        <div className="companies-tab-content">
            {props.series.length == 0 &&
                <ErrorPage
                    imageUrl="/assets/svg/tier-empty-state.svg"
                    errorPageHeading="You’re not following any Series"
                    errorPageDescription="Add a Series to your Watchlist to get started."
                    paraUrl=""
                    paraUrlText=""
                    class="tier"
                />
            }
            {props.series.length > 0 && props.series.map((item, index) => {
                return (
                    <div className="companies-tab-item" key={`expert-card-${index}`}>
                        <div className="row align-items-center">
                            <div className="col-9 col-md-9">
                                <div className="companies-info">
                                    <div className="companies-logo">
                                        <a
                                            href={`/series/${item.name}/${item.id}`}
                                            onClick={event => {
                                                redirectionWrapper(
                                                    'series',
                                                    event,
                                                    item.id,
                                                    item.name,
                                                    props.parentProps,
                                                    props.parentProps.showLoader,
                                                    props.parentProps.hideLoader
                                                )
                                            }
                                            }
                                        >
                                            {!IsEmpty(item.url) &&
                                                <img src={item.url} style={{ maxWidth: "100%" }} />
                                            }
                                            {IsEmpty(item.url) &&
                                                <img src="/assets/ausbiz_series_logo.png" style={{ maxWidth: "100%" }} />
                                            }
                                        </a>
                                    </div>
                                    <div className="companies-title">
                                        <h3
                                            onClick={event => {
                                                redirectionWrapper(
                                                    'series',
                                                    event,
                                                    item.id,
                                                    item.name,
                                                    props.parentProps,
                                                    props.parentProps.showLoader,
                                                    props.parentProps.hideLoader
                                                )
                                            }
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            {item.name}
                                        </h3>
                                        {item.seriesSchedule.length > 0 &&
                                            <span style={{ cursor: "auto" }} className="light-blue date-icon-line">
                                             <small>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                                                    <g fill="none" fill-rule="evenodd">
                                                        <g fill="#7d89a0" fill-rule="nonzero">
                                                            <g>
                                                                <g>
                                                                    <g>
                                                                        <path d="M12.5 17c.828 0 1.5-.672 1.5-1.5v-11c0-.828-.672-1.5-1.5-1.5H11V1.375c0-.206-.169-.375-.375-.375h-1.25C9.169 1 9 1.169 9 1.375V3H5V1.375C5 1.169 4.831 1 4.625 1h-1.25C3.169 1 3 1.169 3 1.375V3H1.5C.672 3 0 3.672 0 4.5v11c0 .828.672 1.5 1.5 1.5h11zm-.188-1.5H1.687c-.103 0-.187-.084-.187-.188V6h11v9.312c0 .104-.084.188-.188.188z" transform="translate(-305.000000, -357.000000) translate(305.000000, 261.000000) translate(0.000000, 50.000000) translate(0.000000, 45.000000)"/>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                              </small>
                                                {item && item.seriesSchedule}
                                            </span>
                                        }

                                        {item.relatedTopics.length > 0 &&
                                            <div className="companies-info-footer info-footer-w100"> 
                                                <ul>
                                                    {item.relatedTopics.map((relatedTopic, relatedTopicIndex) => {
                                                        return (
                                                            <li
                                                                onClick={event => {
                                                                    redirectionWrapper(
                                                                        'topic',
                                                                        event,
                                                                        relatedTopic.id,
                                                                        relatedTopic.name,
                                                                        props.parentProps,
                                                                        props.parentProps.showLoader,
                                                                        props.parentProps.hideLoader,
                                                                        props.parentProps.currentLanguage
                                                                    )
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                                key={`series-${relatedTopicIndex}`}
                                                            >
                                                                {relatedTopic.name}
                                                            </li>
                                                        );
                                                    })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 col-md-3">
                                <div className="companies-follow-btns">
                                    <span className={!item.isFollowing ? "nofollow-btn" : "nofollow-btn hide"} onClick={() => props.followObject(item.id, "series")} >Follow</span>
                                    {props.unFollowObject &&
                                        <span className={item.isFollowing ? "follow-btn gray-follow-btn" : "follow-btn hide"} onClick={() => props.unFollowObject(item.id, "series")} >Following</span>
                                    }
                                    {!props.unFollowObject &&
                                        <span className={item.isFollowing ? "follow-btn gray-follow-btn disable-unfollow" : "follow-btn hide"} >Following</span>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                );
            })
            }
        </div>
    );
};

export default SeriesHorizontalWideCard;
